// IMPORT REACT
import React from 'react';
import bsCustomFileInput from 'bs-custom-file-input';

// IMPORT STYLES
import { SC_FormGroup, SC_Label, SC_FormControlInput, SC_FormControlSelect, SC_FormCheck, SC_FormControlFile } from '../styles';

const YAInput = (props) => {
	bsCustomFileInput.init();
	return (
		<SC_FormGroup>
			<SC_Label htmlFor={props.id}>{props.label}</SC_Label>
			{props.type == 'select' ?
				<SC_FormControlSelect onChange={props.onChange} defaultValue={props.value} id={props.id} name={props.name ? props.name : props.id} className={props.is ? 'is-' + props.is : null} disabled={props.disabled}>
					<option value="">Select...</option>
					{props.options ? props.options.map((option) => {
						return <option value={option.value} key={option.value}>{option.label}</option>
					}) : null}
				</SC_FormControlSelect>
				: props.type == 'checkbox' ?
					props.options ? props.options.map((option) => {
						return <SC_FormCheck key={option.id}>
							<input type="checkbox" defaultChecked={option.value} className="form-check-input" id={option.id} name={option.id} />
							<SC_Label htmlFor={option.id} className="form-check-label">
								{option.label}
							</SC_Label>
						</SC_FormCheck>
					}) : null

					: props.type == 'file' ?

						<SC_FormControlFile>
							<input type="file" className="custom-file-input" name={props.name ? props.name : props.id} onChange={props.onChange}
							/>
							<label className="custom-file-label" htmlFor={props.id}>Choose file</label>
						</SC_FormControlFile>

						:
						<SC_FormControlInput disabled={props.disabled} type={props.type} id={props.id} name={props.name ? props.name : props.id} defaultValue={props.value} className={props.is ? 'is-' + props.is : null} />
			}

		</SC_FormGroup>
	)

}
export default YAInput;